var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SelectInline", {
        attrs: {
          "characteristic-items": _vm.metaItems,
          "label-type": _vm.labelTypeApplication,
          "single-choice": "",
          "label-type": "application"
        },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.searchStatus,
          callback: function($$v) {
            _vm.searchStatus = $$v
          },
          expression: "searchStatus"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }